// extracted by mini-css-extract-plugin
export default {"productDescription":"waa-z","featuredDescription":"xaa-z","description":"yaa-z","more":"zaa-z","descriptionSku":"Aaa-z"};